import _defineProperty from "/var/jenkins_home/workspace/web_bieyangapp_review_page@2/product-search/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/var/jenkins_home/workspace/web_bieyangapp_review_page@2/product-search/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/var/jenkins_home/workspace/web_bieyangapp_review_page@2/product-search/node_modules/@babel/runtime/regenerator/index.js";
import { __awaiter } from "tslib";
import classNames from 'classnames';
import React, { useState } from 'react';
import { withNativeProps } from '../../utils/native-props';
import { usePropsValue } from '../../utils/use-props-value';
import { mergeProps } from '../../utils/with-default-props';
import { SpinIcon } from './spin-icon';
import { useConfig } from '../config-provider';
import { isPromise } from '../../utils/validate';
var classPrefix = "adm-switch";
var defaultProps = {
  defaultChecked: false
};
export var Switch = function Switch(p) {
  var _classNames;

  var props = mergeProps(defaultProps, p);
  var disabled = props.disabled || props.loading || false;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      changing = _useState2[0],
      setChanging = _useState2[1];

  var _useConfig = useConfig(),
      locale = _useConfig.locale;

  var _usePropsValue = usePropsValue({
    value: props.checked,
    defaultValue: props.defaultChecked,
    onChange: props.onChange
  }),
      _usePropsValue2 = _slicedToArray(_usePropsValue, 2),
      checked = _usePropsValue2[0],
      setChecked = _usePropsValue2[1];

  function onClick() {
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var nextChecked, result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(disabled || props.loading || changing)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              nextChecked = !checked;

              if (!props.beforeChange) {
                _context.next = 15;
                break;
              }

              setChanging(true);
              _context.prev = 5;
              _context.next = 8;
              return props.beforeChange(nextChecked);

            case 8:
              setChanging(false);
              _context.next = 15;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](5);
              setChanging(false);
              throw _context.t0;

            case 15:
              result = setChecked(nextChecked);

              if (!isPromise(result)) {
                _context.next = 28;
                break;
              }

              setChanging(true);
              _context.prev = 18;
              _context.next = 21;
              return result;

            case 21:
              setChanging(false);
              _context.next = 28;
              break;

            case 24:
              _context.prev = 24;
              _context.t1 = _context["catch"](18);
              setChanging(false);
              throw _context.t1;

            case 28:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 11], [18, 24]]);
    }));
  }

  return withNativeProps(props, React.createElement("div", {
    onClick: onClick,
    className: classNames(classPrefix, (_classNames = {}, _defineProperty(_classNames, "".concat(classPrefix, "-checked"), checked), _defineProperty(_classNames, "".concat(classPrefix, "-disabled"), disabled || changing), _classNames)),
    role: 'switch',
    "aria-label": locale.Switch.name,
    "aria-checked": checked,
    "aria-disabled": disabled
  }, React.createElement("div", {
    className: "".concat(classPrefix, "-checkbox")
  }, React.createElement("div", {
    className: "".concat(classPrefix, "-handle")
  }, (props.loading || changing) && React.createElement(SpinIcon, {
    className: "".concat(classPrefix, "-spin-icon")
  })), React.createElement("div", {
    className: "".concat(classPrefix, "-inner")
  }, checked ? props.checkedText : props.uncheckedText))));
};